import { Box, ScrollArea, Stack } from '@mantine/core';

import {
  PROJECT_DETAIL_SCROLL_AREA_VIEWPORT_ID,
  useResponseProjectDetailContext,
} from '../../context/responseProjectDetailContext';
import { useResponseProjectGenerationStatus } from '../../hooks/useResponseProjectGenerationStatus.hooks';
import { ResponseProjectDetailBlocksLoading } from './ResponseProjectDetailBlocksLoading';
import { Block } from './components/Block';

interface ResponseProjectDetailBlocksProps {
  projectId: number;
}

export function ResponseProjectDetailBlocks({
  projectId,
}: ResponseProjectDetailBlocksProps) {
  const { blocks, scrollAreaRef } = useResponseProjectDetailContext();
  const status = useResponseProjectGenerationStatus(projectId);

  if (status === 'pending') {
    return <ResponseProjectDetailBlocksLoading />;
  }

  return (
    <ScrollArea
      viewportRef={scrollAreaRef}
      id={PROJECT_DETAIL_SCROLL_AREA_VIEWPORT_ID}
    >
      <Box w="100%" h="100%">
        <Stack spacing="04" w="100%">
          {blocks.map(block => (
            <Block key={block.id} block={block} />
          ))}
        </Stack>
      </Box>
      <Box w="100%" h="20vh" />
    </ScrollArea>
  );
}
